import React, { useEffect, useState } from 'react';
import './App.css';

import { Chat as ChatWidget, WidgetEnv } from "@xapp/chat-widget";
import "@xapp/chat-widget/dist/index.css";
import { LoadingSpinner } from './components/LoadingSpinner';

function App() {
  const [env, setEnv] = useState<WidgetEnv>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    // expecting /{key}/{sessionId}
    // or new way /{key}?sessionId={sessionId}

    const pathname = window.location.pathname;
    const parameters = pathname.split("/");

    const urlLoc = new URL(window.location.href);

    // using params makes it easier to test in VSC with GoLive or serve
    const key = parameters[1] || urlLoc.searchParams.get("key");
    const sessionId = parameters[2] || urlLoc.searchParams.get("sessionId");
    console.log(`key: "${key}" sessionId: "${sessionId}"`);
    
    if (!key || key.trim().length === 0) {
      setError(Error(`Missing widget key id`));
      return;
    }

    if (!sessionId || sessionId.trim().length === 0) {
      setError(Error(`Missing session id`));
      return;
    }

    const urlConfig = `https://widget.xapp.ai/config.json?key=${key}`;

    fetch(urlConfig).then((resp) => {
      return resp.json();
    }).then((json) => {

      const updated: WidgetEnv = {
        ...json,
        // isAdmin is required to enable the join / leave button
        isAdmin: true,
        // Clear out the header
        // remove buttons and subtitle
        // change title "Agent Chat"
        header: {
          ...json?.header,
          actions: {},
          status: {
            "online": "Agent Chat"
          },
          subtitle: {}
        },
        // clear out autocomplete suggestions as they are intended for the end user
        autocompleteSuggestionsUrl: undefined
      };

      if (updated.connection?.type !== "websocketraw") {
        throw new Error(`Bad server type: ${updated.connection?.type}`)
      }

      setEnv(updated);
    }).catch((error) => {
      setError(error);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  if (error) {
    return (
      <div className="App">
        <div className="Error-Container">
          <h3>I'm sorry, we had an error loading your agent chat.</h3>
          <code>{error.message}</code>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {loading ? <LoadingSpinner loadingText='Loading Agent Chat...' /> : <ChatWidget config={env} mode={"docked"} />}
    </div>
  );
}

export default App;
